import ProjectModel    from 'models/ProjectModel';
import BudgetAggregate from 'models/budgetModels/BudgetAggregateModel';
import { computed }    from 'mobx';

export default class ProjectBudgetModel extends BudgetAggregate(ProjectModel) {
	static get path(): string {
		return '/projects/_budget';
	}

	@computed
	public get targetBudget(): number | null {
		return this.get('budgetTarget', null);
	}
}
